import cn from 'classnames';
import {useHistory, useLocation} from 'react-router';
import React from 'react';
import IconLeft from '../../icon/IconLeft';
import IconRight from '../../icon/IconRight';

type CardPaginatorProps = {
  total: number
  page: number
  perPage: number
  className?: string
  queryParamName?: string
  onPrevClick?: (page: number) => void,
  onNextClick?: (page: number) => void,
}

/**
 * A paginator in the bottom of a dashboard card
 * @param page {number} Current page
 * @param perPage {number} Number of records per page
 * @param total {number} Total number of records
 * @param queryParamName {string} Name of query param to track the history
 * @param onPrevClick {function} Function to handle a switch to Prev page
 * @param onNextClick {function} Function to handle a switch to Next page
 * @constructor
 */
export default function CardPaginator({
  page, perPage, total, queryParamName, className, onPrevClick, onNextClick,
}: CardPaginatorProps) {
  const maxPage = Math.ceil(total / perPage);
  const history = useHistory();
  const location = useLocation();

  const updateHistory = (index: number) => {
    if (queryParamName) {
      const params = new URLSearchParams(location.search);
      params.set(queryParamName, index.toString());
      location.search = params.toString();
      history.push(location);
    }
  };


  const handlePrevClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const newIndex = page - 1;
    updateHistory(newIndex);
    if (onPrevClick) {
      onPrevClick(newIndex);
    }
  };

  const handleNextClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const newIndex = page + 1;
    updateHistory(newIndex);
    if (onNextClick) {
      onNextClick(newIndex);
    }
  };


  return (
    <>
      {maxPage > 1 &&
      <div className={cn('pt-8 pb-2', className)}>
        <div className="grid grid-cols-3 gap-x-3 text-base">
          <div className="col-span-1 text-blue">
            {page !== 1 && <a href="#" data-testid="prev"
              onClick={(e) => handlePrevClick(e)}><IconLeft/>&nbsp;Prev</a>}
          </div>
          <div className="col-span-1 text-gray-dark text-center">{page} / {maxPage}</div>
          <div className="col-span-1 text-right text-blue">
            {page !== maxPage &&
            <a href="#" data-testid="next" onClick={(e) => handleNextClick(e)}>Next&nbsp;&nbsp;
              <IconRight/></a>}
          </div>
        </div>
      </div>
      }
    </>
  );
}

